import Component from '../app/component'
import Glide from '@glidejs/glide'
import ImagesParallax from '../plugins/images-parallax.js'

export default class PostComponent extends Component {
  constructor (el) {
    super(el)
    this.data = {}
  }

  init () {
    new ImagesParallax(this.refs.images)
    this.setup()
  }

  setup () {
    if (this.refs.carousel) {
      this.glide = new Glide(
        this.refs.carousel,
        {
          type: 'carousel',
          startAt: 0,
          perView: 1,
          autoplay: 5000,
          gap: 0
        }
      )
      this.glide.mount()
      
      if (this.refs.next) {
        this.refs.next.addEventListener('click', () => {
          this.glide.go('>')
        })
      }
      
      if (this.refs.prev) {
        this.refs.prev.addEventListener('click', () => {
          this.glide.go('<')
        })
      }
    }
  }
}
